import { ChangeEvent, useEffect, useState } from "react";
import Select, { CSSObjectWithLabel, SingleValue } from "react-select";
import Modal from "../common/Modal/Modal";
import useModal from "../../utils/hooks/useModal";
import useDevice from "../../utils/hooks/useDevice";
import { clearAllBodyScrollLocks } from "body-scroll-lock";
import Button from "../common/Button";
import { Icon } from "../Icon";
import Label from "../Label";
import { displayMoney } from "../../utils/displayMoney";
import { labelColor } from "./util";

type Props = {
  variation: Variation;
  labels: LenghtLabel;
  colors: string[];
  lengths: string[];
  gauges: string[];
  restItem: (e: any) => void;
  sumItem: (e: any) => void;
  handleChange: (e: any) => void;
  handleCreateCustomization: (newCustomization: string | undefined) => void;
  handleEraseCustomization: () => void;
  addOneProduct: CartProduct;
  addPreCart: () => void;
  setIsLoginRequired: (value: boolean) => void;
  isAuth: boolean;
  handleSelectChange: (
    option: SingleValue<{ value: string; label: string }>,
    e: any
  ) => void;
};

const AddVariant: React.FC<Props> = ({
  handleCreateCustomization,
  handleEraseCustomization,
  variation,
  colors,
  lengths,
  gauges,
  restItem,
  sumItem,
  handleChange,
  addOneProduct,
  addPreCart,
  handleSelectChange,
  labels,
  setIsLoginRequired,
  isAuth,
}) => {
  const { isOpen, toggle } = useModal();
  const [customization, setCustomization] = useState(variation?.customization);
  const [noCustomization, setNoCustomization] = useState<boolean>(false);
  useEffect(() => {
    customization && customization.length > 0 && setNoCustomization(false);
  }, [customization]);
  const options = (param: string[]) =>
    param.map((option) => {
      return { label: option, value: option };
    });

  const optionsColors = (param: string[]) =>
    param.map((option) => {
      return {
        label:
          option === "amarillo"
            ? "Amarillo"
            : option === "rojo"
            ? "Rojo"
            : option === "plata"
            ? "Plata"
            : option === "rose"
            ? "Rosé"
            : option === "golden"
            ? "Dorado"
            : option === "soaked"
            ? "Empavonado"
            : "Blanco",
        value: option,
      };
    });

  const optionsLength = (param: string[]) =>
    param.map((option) => {
      return {
        label: option + labels.unit,
        value: option,
      };
    });

  const { width } = useDevice();
  const customStyles = {
    control: (base: CSSObjectWithLabel) => ({
      ...base,
      border: "none",
      boxShadow: "none",
      width: width > 1200 ? "125 px" : "105 px",
      borderRadius: 30,
      fontFamily: "Mont-Regular",
      fontSize: width > 1200 ? 16 : 14,
      fontWeight: "normal",
    }),
    option: (base: CSSObjectWithLabel, state: any) => ({
      ...base,
      cursor: "pointer",
      color: state.isSelected ? "white" : "#221F28",
      backgroundColor: state.isSelected
        ? "#b6966d"
        : state.isFocused && "#F5F5F5",
      fontFamily: "Mont-Regular",
      fontSize: 14,
    }),
  };
  let approximateWeight =
    Number(addOneProduct.weight.replace(",", ".")) * addOneProduct.quantity;

  approximateWeight = Number(approximateWeight.toFixed(1));

  let approximateWeightByUnit = Number(
    addOneProduct.weight.replace(",", ".")
  ).toFixed(1);
  const handleClose = () => {
    clearAllBodyScrollLocks();
    toggle();
  };
  const childrenEditPersonalization = () => {
    return (
      <div className="customizationContainer">
        <div className="customizationPreview">
          <Label tag="p" variants="subtitle" style={{ color: "black" }}>
            Personalizado
          </Label>
          <div onClick={handleClose}>
            <Icon iconName="close_icon" className="customizationPreviewClose" />
          </div>
        </div>
        <p>{addOneProduct.title}:</p>
        <textarea
          className="customizationInput"
          id="customization"
          name="customization"
          value={customization}
          placeholder="Ingrese la personalización"
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
            setCustomization(e.target.value)
          }
        ></textarea>
        <div className="customizationButtons">
          <Button
            applyNewSize
            modifier="tertiary"
            className="customizationButtons_white"
            type="button"
            onClick={() => {
              setCustomization("");
              handleCreateCustomization("");
              handleClose();
            }}
          >
            {"Borrar"}
          </Button>
          <Button
            applyNewSize
            className="customizationButtons_gold"
            type="button"
            onClick={() => {
              handleCreateCustomization(customization);
              handleClose();
            }}
          >
            {"Guardar"}
          </Button>
        </div>
      </div>
    );
  };

  const handleAddPreCart = () => {
    if (!isAuth) {
      setIsLoginRequired(true);
      return;
    }
    if (addOneProduct.isCustom && (customization == "" || !customization)) {
      setNoCustomization(true);
    } else {
      setNoCustomization(false);
      addPreCart();
    }
  };

  return (
    <div className="itemDetail__data__selector">
      <h5 className="itemDetail__data__select__titles">Elegir variante</h5>
      <form className="itemDetail__data__selector__form">
        <div className="itemDetail__data__options">
          <div className="itemDetail__select__container">
            <p className="itemDetail__select__name">Color</p>
            {colors.length == 1 && gauges.length == 1 && lengths.length == 1 ? (
              <Select
                className="prueba"
                options={optionsColors(colors)}
                name="color"
                isDisabled={true}
                value={{
                  value: variation.color,
                  label:
                    variation.color != ""
                      ? labelColor(variation.color)
                      : "Seleccionar",
                }}
                placeholder={"Seleccionar"}
                styles={customStyles}
                isSearchable={false}
              />
            ) : (
              <Select
                className="prueba"
                options={optionsColors(colors)}
                onChange={(value, event) => handleSelectChange(value, event)}
                name="color"
                value={{
                  value: variation.color,
                  label:
                    variation.color != ""
                      ? labelColor(variation.color)
                      : "Seleccionar",
                }}
                placeholder={"Seleccionar"}
                styles={customStyles}
                isSearchable={false}
              />
            )}
          </div>

          <div className="itemDetail__select__container">
            <p className="itemDetail__select__name">{labels.gaugeLabel}</p>

            {gauges.length == 1 && lengths.length == 1 ? (
              <Select
                className="prueba"
                placeholder="Seleccionar"
                options={options(gauges)}
                isDisabled={true}
                name="gauge"
                value={{
                  value: variation.gauge,
                  label: variation.gauge || "Seleccionar",
                }}
                styles={customStyles}
                isSearchable={false}
              />
            ) : (
              <Select
                className="prueba"
                placeholder="Seleccionar"
                options={options(gauges)}
                onChange={(value, event) => handleSelectChange(value, event)}
                name="gauge"
                value={{
                  value: variation.gauge,
                  label: variation.gauge || "Seleccionar",
                }}
                styles={customStyles}
                isSearchable={false}
              />
            )}
          </div>
          <div className="itemDetail__select__container">
            <p className="itemDetail__select__name">{labels.lenghtLabel}</p>

            {gauges.length == 1 && lengths.length == 1 ? (
              <Select
                className="prueba"
                placeholder="Largo"
                options={optionsLength(lengths)}
                isDisabled={true}
                name="length"
                value={{
                  value: variation.length,
                  label: variation.length
                    ? variation.length + labels.unit
                    : "Seleccionar",
                }}
                styles={customStyles}
                isSearchable={false}
              />
            ) : (
              <Select
                className="prueba"
                placeholder="Largo"
                options={optionsLength(lengths)}
                onChange={(value, event) => handleSelectChange(value, event)}
                name="length"
                value={{
                  value: variation.length,
                  label: variation.length
                    ? variation.length + labels.unit
                    : "Seleccionar",
                }}
                styles={customStyles}
                isSearchable={false}
              />
            )}
          </div>
          <div className="itemDetail__data__selector__form__quantity">
            <p className="itemDetail__select__name">Cantidad</p>
            <button
              className="itemDetail__data__selector__form__quantity__button button__left"
              onClick={restItem}
              type={"button"}
            >
              -
            </button>
            <input
              type={"text"}
              name="quantity"
              value={addOneProduct.quantity}
              onChange={handleChange}
            ></input>
            <button
              className="itemDetail__data__selector__form__quantity__button button__right"
              onClick={sumItem}
              type={"button"}
            >
              +
            </button>
          </div>
          {isOpen && (
            <Modal
              isOpen={true}
              toggle={toggle}
              children={childrenEditPersonalization()}
            />
          )}
        </div>
        <div className="itemDetail__data__details">
          <p className="itemDetail__data__info">
            {approximateWeightByUnit}gr
            <span>Peso U.</span>
          </p>
          <p className="itemDetail__data__info">
            {approximateWeight}gr
            <span>Peso</span>
          </p>
          {isAuth ? (
            <p className="itemDetail__data__info">
              {addOneProduct.manufacturValue == 0
                ? "A consultar"
                : displayMoney(
                    addOneProduct.manufacturValue * addOneProduct.quantity
                  )}
              <span className="itemDetail__data__manufactur">Hechura</span>
            </p>
          ) : null}
          <button
            className="itemDetail__data__selector__precart__add"
            type={"button"}
            onClick={handleAddPreCart}
          >
            Agregar
          </button>
        </div>
      </form>

      {(addOneProduct.isCustom ||
        addOneProduct.category.includes("isCustom")) && (
        <div className="customization_item">
          <span title="Personalizar" onClick={toggle}>
            <Icon
              iconName="edit-icon-squared"
              className="customization_item_icon"
            />
            <p>
              {variation.customization == "" || !variation.customization
                ? "Personalizar"
                : "Personalizado"}
            </p>
          </span>{" "}
          {addOneProduct.isCustom && noCustomization && (
            <p className="itemDetail_data_msg" style={{ marginLeft: "4px" }}>
              Complete la personalización!
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default AddVariant;
